import api from '../client';

export type TesterFeedbackStatus = 0 | 1;

export interface TesterFeedbackUser {
  id: string;
  username: string;
  fullname: string;
}

export interface TesterFeedback {
  id: string;
  firmId: string;
  userId: string;
  description: string;
  pageUrl: string | null;
  userAgent: string | null;
  status: TesterFeedbackStatus;
  isDeleted: boolean;
  createdAt: string;
  resolvedAt: string | null;
  user?: TesterFeedbackUser;
}

export interface CreateTesterFeedbackDto {
  description: string;
  pageUrl?: string;
}

export const testerFeedbackApi = {
  create: (dto: CreateTesterFeedbackDto) =>
    api.post<TesterFeedback>('/tester-feedback', dto).then(r => r.data),

  list: (params?: { status?: TesterFeedbackStatus }) =>
    api.get<TesterFeedback[]>('/tester-feedback', { params }).then(r => r.data),

  patchStatus: (id: string, status: TesterFeedbackStatus) =>
    api.patch<TesterFeedback>(`/tester-feedback/${id}/status`, { status }).then(r => r.data),
};
